"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStateArgForMergeableState = exports.useMergeableState = void 0;
var React = require("react");
/**
 * This acts just like `React.useState`, except that it returns an updater function that can
 * accept a partial state object and merge it in (like class-based components), instead of just overwriting it.
 *
 * In order to use the merge capability (not a primitive or function), the state must be an object.
 * If the state is a primitive, updating the state will overwrite its value.
 *
 * **CAUTION:** This pattern is provided for maximum flexibility with shared components. Consider the
 * following idiomatic alternatives before deciding that this hook is the best way to manage your use case.
 * - If you have multiple *independent* pieces of state, store them via separate `useState` hooks.
 * - If you have multiple *related* pieces of state, consider modeling them as an object but using
 *   `useReducer` to update them like a state machine.
 * - If you are using a piece of framework that exposes a single mergeable state variable (e.g.
 *   `ReactActionDialog` or `useInlineEditor`), but your state actually contains multiple related
 *   pieces, consider using the `useSetStateAsReducer` hook to allow updating it like a state machine.
 */
function useMergeableState(initialState) {
    var _a = React.useState(initialState), state = _a[0], setState = _a[1];
    var merge = React.useCallback(function (newState) { return setState(setStateArgForMergeableState(newState)); }, [setState]);
    return [state, merge];
}
exports.useMergeableState = useMergeableState;
/**
 * Converts the `setState` argument for a mergeable state to one that can be sent to the normal `setState`.
 */
function setStateArgForMergeableState(newState) {
    if (typeof newState === 'object') {
        return function (prev) { return (__assign(__assign({}, prev), newState)); };
    }
    else { // function or primitive
        return newState;
    }
}
exports.setStateArgForMergeableState = setStateArgForMergeableState;
//# sourceMappingURL=useMergeableState.js.map